<template>
  <SideModal
    :show="show"
    @update:show="
      {
        if (!state.loadingSave) $emit('update:show', $event);
      }
    "
    location="left"
    close-on-overlay-click
  >
    <form @submit.prevent="save" class="modal-container" data-cy="add-entity-form">
      <div class="modal-top">
        <Typography color="primary" weight="600" size="1.25rem">Add Parent</Typography>
        <v-btn
          @click="
            {
              if (!state.loadingSave) $emit('update:show', false);
            }
          "
          variant="plain"
          color="normal"
          icon
          ><v-icon color="gray600">mdi-close</v-icon></v-btn
        >
      </div>

      <div class="modal-body">
        <div>
          <v-text-field
            class="custom-input"
            color="primary"
            label="First Name"
            v-model="state.firstname"
            data-cy="form-fname"
          ></v-text-field>

          <FormValidate
            :validate="state.firstname"
            :regex="/^.{1,50}$/"
            title="First name must be a string of 1 to 50 characters"
          ></FormValidate>
        </div>
        <div>
          <v-text-field
            class="custom-input"
            color="primary"
            label="Last Name"
            v-model="state.lastname"
            data-cy="form-lname"
          ></v-text-field>
          <FormValidate
            :validate="state.firstname"
            :regex="/^.{1,50}$/"
            title="Last name must be a string of 1 to 50 characters"
          ></FormValidate>
        </div>
        <div>
          <v-text-field
            class="custom-input"
            color="primary"
            label="E-Mail"
            v-model="state.email"
            required
            type="email"
            data-cy="form-email"
          ></v-text-field>
          <FormValidate email :validate="state.email" title="Field must be an email"></FormValidate>
        </div>
        <div>
          <v-text-field
            class="custom-input"
            color="primary"
            label="Phone Number"
            v-model="state.phone"
          ></v-text-field>
          <FormValidate
            :validate="state.phone"
            :regex="/^.{0,15}$/"
            title="Phone Number must be a string of 0 to 15 characters"
          ></FormValidate>
        </div>
        <div>
          <v-btn
            width="100%"
            type="submit"
            :loading="state.loadingSave"
            style="text-transform: capitalize"
            data-cy="form-save-btn"
            :data-loading="state.loadingSave ? true : undefined"
            >Save</v-btn
          >
        </div>
      </div>
    </form>
  </SideModal>
</template>

<script setup lang="ts">
import SideModal from "@/components/sideModal.vue";
import Typography from "@/components/typography.vue";
import { watch } from "vue";
import { reactive } from "vue";
import { useAlertsStore } from "@/stores/alerts";
import useParents from "@/stores/school/parents";
import FormValidate from "@/components/formValidate.vue";

const props = defineProps<{
  show: boolean;
}>();

const parentsS = useParents();

const state = reactive({
  loadingSave: false,
  firstname: "",
  lastname: "",
  email: "",
  phone: ""
});

watch([() => props.show], () => {
  Object.assign(state, {
    loadingSave: false,
    firstname: "",
    lastname: "",
    email: "",
    phone: ""
  });
});

const emit = defineEmits<{
  (e: 'update:show', ...args: any[]): void;
  (e: 'update:search', ...args: any[]): void
}>();

const save = async () => {
  state.loadingSave = true;
  // add parent
  const res = await parentsS.createParent({
    firstname: state.firstname,
    lastname: state.lastname,
    email: state.email,
    phone: state.phone
  });
  useAlertsStore().addAlert(
    res ? "success" : "error",
    res ? "Parent added successfully" : "Failed to add new parent, try again later",
    7
  );
  if (res) emit("update:search", state.email);
  state.loadingSave = false;
};
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.modal-container {
  padding: 30px;

  .modal-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .modal-body {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 30px;
  }
}
</style>
